module.exports = __webpack_public_path__ + "static/img/fish100.d79f2a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish/fish100.png
// module id = I+1t
// module chunks = 0